import { consoleAPI } from '@/providers/apis/console/console';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

export default {
    namespaced: true,

    state: {
        partnerList: {},
        modifiedPartnerList: {},
        conentProviderPartnerList: [],
        selectedData: {},
    },

    mutations: {
        getPartnerList(state: any, partnerLists: any) {
            state.partnerList = partnerLists;
        },
        getModifiedPartnerList(state: any, partnerLists: any) {
            state.modifiedPartnerList = partnerLists;
        },
        getModifiedConentProviderPartnerList(state: any, partnerLists: any) {
            state.conentProviderPartnerList = partnerLists;
        },
        getSelectedData(state: any, params: any) {
            state.selectedData = params;
        },
    },

    actions: {
        fetchPartnerList({ commit }: any) {
            consoleAPI.fetchPartnerList().then((partner) => {
                commit('getPartnerList', partner);
            });
        },
        fetchModifiedPartnerList({ commit }: any) {
            return consoleAPI.fetchModifiedPartnerList().then((partner) => {
                commit('getModifiedPartnerList', partner);
                return partner;
            });
        },

        fetchModifiedConentProviderPartnerList({ commit }: any) {
            consoleAPI.fetchModifiedConentProviderPartnerList().then((partner) => {
                commit('getModifiedConentProviderPartnerList', partner);
            });
        },
        passSelectedData({ commit }: any, params: any) {
            commit('getSelectedData', params);
        },
    },
};
